export default __webpack_public_path__ + "static/media/Spanish(MX).49e2e976.svg";